export enum EntryPageEnum {
  Landing = 'Landing',
  BuyerType = 'BuyerType',
  MortgageSwitchUrgency = 'MortgageSwitchUrgency',
}
